import { jsx, jsxs } from "react/jsx-runtime";
import { Button, Text } from "@nxt-costco-com/forge-components";
import { SWATCH_OVERFLOW_COUNTER_TEST_ID } from "../constants.js";
import { containerStyles } from "./styles.js";
const SwatchIcon = (props) => {
  const { overflowCount, pdpNavigationUrl, moreOptionsText } = props;
  const ariaLabelText = `+${overflowCount} ${moreOptionsText}`;
  return /* @__PURE__ */ jsx(
    Button,
    {
      "aria-label": ariaLabelText,
      "data-testid": SWATCH_OVERFLOW_COUNTER_TEST_ID,
      href: pdpNavigationUrl,
      sx: containerStyles,
      variant: "text-button",
      children: /* @__PURE__ */ jsxs(Text, { bold: true, color: "white", variant: "t7", children: [
        "+",
        overflowCount
      ] })
    }
  );
};
export {
  SwatchIcon
};
